import { mutatorAction } from 'satcheljs';
import { getStore } from '../store/store';

/**
 * Sets whether display ads are enabled in current session
 * @param areDisplayAdsEnabled boolean
 */
const setAreDisplayAdsEnabledMutator: (areDisplayAdsEnabled: boolean) => void = mutatorAction(
    'setAreDisplayAdsEnabled',
    (areDisplayAdsEnabled: boolean): void => {
        getStore().areDisplayAdsEnabled = areDisplayAdsEnabled;
    }
);
export default setAreDisplayAdsEnabledMutator;
